import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Mission {
  id: string;
  name: string;
  description: string;
  difficulty: string;
  reward: string;
  status: 'pending' | 'in-progress' | 'completed' | 'failed';
}

export interface MissionsState {
  missions: Mission[];
}

const initialState: MissionsState = {
  missions: [],
};

const missionsSlice = createSlice({
  name: 'missions',
  initialState,
  reducers: {
    addMission: (state, action: PayloadAction<Mission>) => {
      state.missions.push(action.payload);
    },
    updateMissionStatus: (state, action: PayloadAction<{ id: string; status: Mission['status'] }>) => {
      const mission = state.missions.find(m => m.id === action.payload.id);
      if (mission) {
        mission.status = action.payload.status;
      }
    },
    removeMission: (state, action: PayloadAction<string>) => {
      state.missions = state.missions.filter(m => m.id !== action.payload);
    },
    // Add more reducers as needed
  },
});

export const { addMission, updateMissionStatus, removeMission } = missionsSlice.actions;
export default missionsSlice.reducer;